//use this at end of variable to remove comma's (.replace(/,/g, ''))
//use this at end of variable to remove all string except "." (.replace(/[^\d.-]/g, ''))


//gets number of decimal places of the parameter number
export function decimalPlaces(num) {
  var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) { return 0; }
  return Math.max(
       0,
       // Number of digits right of decimal point.
       (match[1] ? match[1].length : 0)
       // Adjust for scientific notation.
       - (match[2] ? +match[2] : 0));
}

//generate number with commas
export function numberWithCommas(x) {
	x=x.replace(/,/g, '');
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//generate round decimal
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
//round(1.005, 2); // 1.01

